// extracted by mini-css-extract-plugin
module.exports = {"form":"recover_form__Av5tN","block":"recover_block__2RcWd","input":"recover_input__3JTYW","footer":"recover_footer__3riJB","buttonBlock":"recover_buttonBlock__2J4uS"};